import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import logo from "../../assets/logo_oxe-tech.png";
import { store } from "../../store";
import { useAuth } from "../../hooks/auth/AuthContext";

import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Badge from "@mui/material/Badge";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { seeNotifications } from "../../store/modules/user/actions";
import {
  azulOxeWork,
  gradienteLaranja,
  roxoEscuro,
} from "../../utils/styledVariables";
import Painel from "../Notificacoes/painel";
import HeaderSectiDash from "../HeaderSectiDash";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const pages = [
  { name: "Meu perfil", url: "/dashboard" },
  // { name: "Cursos", url: "/cursos" },
  { name: "OxeDin", url: "/oxedin" },
  { name: "OxeTech Work", url: "/oxe-tech-work" },
  { name: "Editar dados", url: "/account" },
  { name: "Sair", url: "sair" },
];

const isActive = window.location.pathname;

// Primeiro e segundo nome, sem caixa alta ("MARCELO LUCAS DE OLIVEIRA" -> "Marcelo Lucas").
function nomeCurto(nome) {
  const partes = String(nome || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
  return partes
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(" ");
}

// Psicóloga do Academy (row ativa em academy_psicologas) não tem campo no
// profile: só a API sabe. Uma consulta por usuário enquanto a página não
// recarrega — o Header monta em toda tela e a resposta quase nunca muda.
const psicologaPorUsuario = new Map();
function consultarPsicologa(userId) {
  if (!psicologaPorUsuario.has(userId)) {
    psicologaPorUsuario.set(
      userId,
      api
        .get("/academy/psicologa/me")
        // admin também recebe ok:true (com isAdmin), mas sem `psicologa`
        .then((res) => Boolean(res?.data?.ok && res?.data?.psicologa && !res?.data?.isAdmin))
        .catch(() => false)
    );
  }
  return psicologaPorUsuario.get(userId);
}

const ResponsiveAppBar = (props) => {
  let profile = useSelector((state) =>
    state.user.profile.dataValues
      ? state.user.profile.dataValues
      : state.user.profile
  );
  const dispatch = useDispatch();
  function getName() {
    let name;

    if (profile.razao_social) {
      name = profile.razao_social.split("")[0];
    }

    if (profile.nome_social) {
      name = profile.nome_social.split("")[0];
    } else if (profile.name) {
      name = profile.name.split("")[0];
    }

    return name;
  }

  // Nome por extenso e papel, para o cluster do topo. O `getName()` acima
  // devolve so a INICIAL (e usado dentro do avatar), entao nao serve aqui.
  function getFullName() {
    return profile.nome_social || profile.name || profile.razao_social || "";
  }

  // Mesma deteccao que o getNotificationEndpoint() ja usa mais abaixo:
  // `reponsibility` (o typo e do modelo) = admin, `cnpj` = empresa.
  // Mantida uma funcao so para os dois nao saírem do lugar juntos.
  // Devolve null quando NAO da para saber. O default "Aluno" era pior que nao
  // rotular: enquanto o profile nao chega (primeiro paint antes do rehydrate,
  // ou payload fora do formato) o topo afirmava "Aluno" para todo mundo,
  // inclusive para um administrador logado.
  function getRole() {
    if (profile.reponsibility !== undefined) return "Administrador";
    if (profile.cnpj !== undefined) return "Empresa";
    if (ehPsicologa) return "Psicóloga";
    if (profile.cpf !== undefined) return "Aluno";
    return null;
  }

  // Só pergunta para quem tem cara de aluno: admin e empresa já se resolvem
  // pelo profile, e a psicóloga entra com conta de aluno.
  const [ehPsicologa, setEhPsicologa] = useState(false);
  useEffect(() => {
    if (!profile?.id || profile?.cpf === undefined || profile?.reponsibility !== undefined) return;
    let ativo = true;
    consultarPsicologa(profile.id).then((sim) => {
      if (ativo) setEhPsicologa(sim);
    });
    return () => {
      ativo = false;
    };
  }, [profile?.id, profile?.cpf, profile?.reponsibility]);

  const { history } = props;
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const location = useLocation();
  const { logout } = useAuth();
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleMenuClick = (pageURL) => {
    handleCloseNavMenu();
    history.push(pageURL);
  };

  function handleSignOut() {
    logout();
  }
  //Notificações
  const [notificacoes, setNotificacoes] = useState([]);

  const [anchorNotif, setAnchorNotif] = useState(null);

  const [hasNewNotifications, setHasNewNotifications] = useState(false);

  //Identificar o usuário e usar a rota
  const getNotificationEndpoint = () => {
    if (profile.cpf !== undefined && profile.reponsibility === undefined) {
      //É aluno
      return "/aluno/see-notifications";
    } else if (profile.cnpj !== undefined) {
      //É empresa
      return "/empresa/see-notifications";
    } else if (profile.reponsibility !== undefined) {
      //É admin
      return "/admin-see-notifications";
    }
  };

  const markAllNotificationAsSeen = async () => {
    if (hasNewNotifications) {
      const endpoint = getNotificationEndpoint();
      setNotificacoes(
        notificacoes.map((notificacao) => ({ ...notificacao, seen: true }))
      );
      await api.patch(endpoint, { userId: profile.id });

      // profile.notificacoes = notificacoes;
      dispatch(seeNotifications(profile, endpoint));
    }
  };
  //Checar se tem novas notificações para ativar o badge
  const checkHasNewNotifications = () => {
    if (notificacoes.length === 0) {
      setHasNewNotifications(false);
    }

    for (const notificacao of notificacoes) {
      if (notificacao.seen === false) {
        setHasNewNotifications(true);
        break;
      }
    }
  };

  useEffect(() => {
    if (profile && Array.isArray(profile.notificacoes)) {
      setNotificacoes(profile.notificacoes);
    }
  }, [profile]);

  useEffect(() => {
    checkHasNewNotifications();
  }, [notificacoes]);

  // Expõe a altura efetiva do Header como CSS variable global, para que
  // sidebars fixadas (AppSidebar) possam começar abaixo dele.
  // Usa useLayoutEffect + dep em location.pathname para que a var seja
  // re-medida SINCRONAMENTE antes do paint a cada mudança de rota — caso
  // contrário sidebars como /perfil-laboratorio/:labId e /academy-psicologa
  // ficam com top:0 e seu conteúdo de topo (card do lab, avatar admin) fica
  // escondido atrás do header. ResizeObserver cobre mudanças dinâmicas
  // (HeaderSectiDash usa 5vh, que muda em resize). NÃO zera no unmount —
  // o DefaultLayout zera explicitamente quando precisa.
  const appBarRef = React.useRef(null);
  React.useLayoutEffect(() => {
    const setVar = () => {
      const h = appBarRef.current?.offsetHeight || 0;
      if (h > 0) {
        document.documentElement.style.setProperty(
          "--app-header-height",
          `${h}px`
        );
      }
    };
    setVar();
    // Em alguns casos o offsetHeight inicial pode ser 0 (fontes/imagens ainda
    // carregando). Garante uma nova medição no próximo frame.
    const raf = window.requestAnimationFrame(setVar);
    window.addEventListener("resize", setVar);
    let ro;
    if (typeof ResizeObserver !== "undefined" && appBarRef.current) {
      ro = new ResizeObserver(setVar);
      ro.observe(appBarRef.current);
    }
    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener("resize", setVar);
      if (ro) ro.disconnect();
    };
  }, [location.pathname]);

  const hadleOpenNotif = (event) => {
    setAnchorNotif(event.currentTarget);
  };

  const handleCloseNotif = async () => {
    // Marcar todas as notificações como lidas
    // Fechar a aba de notificações
    setAnchorNotif(null);
    setHasNewNotifications(false);
    await markAllNotificationAsSeen();
  };

  // Em rotas do OxeTech Work, exibe apenas a faixa azul SECTI no topo
  // (sem o AppBar laranja OXETECH) — o OxeTech Work já tem seu próprio header
  // roxo "OXETECHwork" abaixo, com logo+menu. Manter SECTI mantém identidade
  // institucional sem poluir com o laranja redundante.
  const isWorkRoute =
    location.pathname === "/oxetechwork" ||
    location.pathname === "/oxe-tech-work" ||
    location.pathname.indexOf("oxetechwork-inscricao") !== -1 ||
    location.pathname.indexOf("oxetechwork-inscritos") !== -1;

  if (isWorkRoute) {
    return (
      <Box
        ref={appBarRef}
        sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1300 }}
      >
        <HeaderSectiDash />
      </Box>
    );
  }

  // Header global SECTI + OXETECH aparece em TODAS as outras telas autenticadas.
  return (
    <ThemeProvider theme={theme}>
      <AppBar
        ref={appBarRef}
        style={{
          background: "#df622e",
          // `fixed` em vez de `sticky` evita que o Header desapareça ao
          // rolar quando o `#root` global tem `overflow-x: hidden` (que em
          // alguns navegadores quebra o sticky por criar um scroll container).
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
        }}
        elevation={0}
      >
        <HeaderSectiDash />
        <Container maxWidth="100vw">
          <Toolbar disableGutters sx={{ padding: "1", position: "relative" }}>
            {/* Logo centralizada — posição absoluta relativa à Toolbar inteira */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
                display: { xs: "none", sm: "flex" },
              }}
            >
              <Tooltip title="Logo OxeTech">
                <IconButton onClick={() => handleMenuClick("/")}>
                  <img src={logo} alt="OxeTech" width={"80%"} />
                </IconButton>
              </Tooltip>
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
              }}
            >
              {/* Notificações à direita */}
              <Box sx={{ marginLeft: "auto" }}>
                <Tooltip title="Notificações" arrow>
                  <IconButton
                    onClick={hadleOpenNotif}
                    sx={{
                      // Quadrado arredondado translucido do modelo, no lugar do
                      // botao redondo sem fundo.
                      margin: "4px",
                      width: 40,
                      height: 40,
                      borderRadius: "11px",
                      backgroundColor: "rgba(255,255,255,.16)",
                      transition: "background-color .15s",
                      "&:hover": { backgroundColor: "rgba(255,255,255,.26)" },
                    }}
                  >
                    <Badge
                      overlap="circular"
                      badgeContent=" "
                      variant="dot"
                      sx={{
                        // A bolinha era LARANJA sobre a barra laranja, ou seja,
                        // invisivel justamente quando havia notificacao nova.
                        // Branca com anel da cor da barra, que e como o modelo
                        // destaca o badge.
                        "& .MuiBadge-badge": {
                          backgroundColor: "#fff",
                          boxShadow: "0 0 0 2px #df622e",
                        },
                      }}
                      invisible={!hasNewNotifications}
                    >
                      <NotificationsNoneOutlinedIcon sx={{ color: "white" }} />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Painel
                  anchorNotif={anchorNotif}
                  handleCloseNotif={handleCloseNotif}
                  notificacoes={notificacoes || []}
                />
              </Box>
            </Box>

            {/* ---------- Visível para Mobile ----------*/}
            <Box sx={{ flexGrow: 1, display: { xs: "flex", sm: "none" } }}>
              <IconButton
                aria-label="Páginas do OxeTech"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
                sx={{
                  display:
                    location.pathname !== "/dashboard" &&
                    location.pathname !== "/empresa-account" &&
                    location.pathname !== "/dashadmin"
                      ? { xs: "flex", sm: "none" }
                      : { xs: "none", sm: "none" },
                }}
              >
                <MenuIcon fontSize="40px" />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", sm: "none" },
                }}
              >
                {profile.razao_social ? (
                  <MenuItem onClick={() => handleMenuClick(pages[0].url)}>
                    <Typography textAlign="center">{pages[0].name}</Typography>
                  </MenuItem>
                ) : (
                  pages.map((page) => (
                    <MenuItem
                      key={page.name}
                      onClick={() =>
                        page.name !== "Sair"
                          ? handleMenuClick(page.url)
                          : handleSignOut()
                      }
                    >
                      <Typography textAlign="center">{page.name}</Typography>
                    </MenuItem>
                  ))
                )}
              </Menu>
            </Box>

            <Box
              sx={{
                flexGrow:
                  location.pathname !== "/dashboard" &&
                  location.pathname !== "/empresa-account" &&
                  location.pathname !== "/dashadmin"
                    ? 2
                    : 1,
                display: { xs: "flex", sm: "none" },
              }}
            >
              <Tooltip title="Logo OxeTech">
                <IconButton onClick={() => handleMenuClick("/")}>
                  <img src={logo} alt="OxeTech" width={"80%"} />
                </IconButton>
              </Tooltip>
            </Box>
            {/* ---------- FIM Visível para Mobile ----------*/}

            <Box
              sx={{
                flexGrow: 0,
                display:
                  location.pathname !== "/empresa-account" &&
                  location.pathname !== "/dashadmin"
                    ? { xs: "none", sm: "flex" }
                    : { xs: "none", sm: "none" },
              }}
            >
              {/* O "Meu perfil" saiu do topo porque repetia o nome/papel
                  exibidos ao lado do avatar. O "Inicio" virou so a casinha, no
                  mesmo quadrado translucido do sino; o rotulo fica no tooltip. */}
              {location.pathname === "/dashboard" && (
                <Tooltip title="Início" arrow>
                  <IconButton
                    component={Link}
                    to="/"
                    aria-label="Início"
                    sx={{
                      margin: "4px",
                      alignSelf: "center",
                      width: 40,
                      height: 40,
                      borderRadius: "11px",
                      backgroundColor: "rgba(255,255,255,.16)",
                      transition: "background-color .15s",
                      "&:hover": { backgroundColor: "rgba(255,255,255,.26)" },
                    }}
                  >
                    <HomeOutlinedIcon sx={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
              )}

              {/* Cluster de conta na pegada do modelo: nome por extenso com o
                  papel embaixo, e o avatar como circulo AZUL CHEIO com a inicial
                  em branco. Antes era so um avatar cinza claro com a inicial em
                  preto, que sumia sobre o laranja da barra.
                  O bloco de texto some abaixo de `md` para nao competir com o
                  logo em tela estreita; o avatar continua sempre visivel. */}
              <Tooltip title="Conta" arrow>
                <IconButton
                  sx={{
                    // Pilula translucida com borda (modelo novo da conta).
                    pr: "10px",
                    pl: "20px",
                    py: "5px",
                    gap: "12px",
                    borderRadius: "999px",
                    backgroundColor: "rgba(255,255,255,.14)",
                    border: "1.5px solid rgba(255,255,255,.35)",
                    "&:hover": { backgroundColor: "rgba(255,255,255,.22)" },
                  }}
                  onClick={(e) => setAnchorElUser(e.currentTarget)}
                  aria-controls={anchorElUser ? "user-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={Boolean(anchorElUser)}
                >
                  {/* `component="span"`: o IconButton renderiza um <button>, e o
                      conteudo dele so aceita phrasing content. Um <div> ali e
                      aninhamento invalido. */}
                  <Box
                    component="span"
                    sx={{
                      display: getFullName() ? { xs: "none", md: "flex" } : "none",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      lineHeight: 1.2,
                      minWidth: 0,
                    }}
                  >
                    <Typography
                      component="span"
                      sx={{
                        fontSize: 14.5,
                        fontWeight: 700,
                        color: "#fff",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 220,
                      }}
                    >
                      {nomeCurto(getFullName())}
                    </Typography>
                    {getRole() && (
                      <Typography
                        component="span"
                        sx={{ fontSize: 12.5, color: "rgba(255,255,255,.82)", whiteSpace: "nowrap" }}
                      >
                        {getRole()}
                      </Typography>
                    )}
                  </Box>

                  <Avatar
                    className="avatar"
                    src={profile?.avatar_url || undefined}
                    alt={getFullName() || "Perfil"}
                    sx={{
                      width: 42,
                      height: 42,
                      border: "2.5px solid rgba(255,255,255,.85)",
                      backgroundColor: "#2C5FA8",
                      color: "#fff",
                      fontSize: 18,
                      fontWeight: 700,
                    }}
                  >
                    {getName()}
                  </Avatar>
                  <KeyboardArrowDownRoundedIcon
                    sx={{
                      color: "rgba(255,255,255,.9)",
                      fontSize: 22,
                      ml: "-4px",
                      transition: "transform .2s",
                      transform: anchorElUser ? "rotate(180deg)" : "none",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {/* Menu da conta no modelo novo: cabecalho com avatar, nome e
                  e-mail; atalhos com icone; "Sair da conta" separado em vermelho. */}
              <Menu
                id="user-menu"
                anchorEl={anchorElUser}
                open={Boolean(anchorElUser)}
                onClose={() => setAnchorElUser(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                PaperProps={{
                  sx: {
                    mt: "10px",
                    width: 300,
                    maxWidth: "calc(100vw - 24px)",
                    borderRadius: "16px",
                    border: "1px solid #EDE4D6",
                    boxShadow: "0 18px 40px rgba(70,45,20,.14)",
                    fontFamily: "'Poppins', system-ui, sans-serif",
                    "& .MuiList-root": { py: 0 },
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "14px", p: "18px 20px", borderBottom: "1px solid #F1EBE1" }}>
                  <Avatar
                    src={profile?.avatar_url || undefined}
                    alt={getFullName() || "Perfil"}
                    sx={{ width: 48, height: 48, flex: "none", backgroundColor: "#2C5FA8", color: "#fff", fontSize: 19, fontWeight: 700 }}
                  >
                    {getName()}
                  </Avatar>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontFamily: "inherit", fontSize: 15, fontWeight: 700, color: "#1F1E1C", lineHeight: 1.3, overflowWrap: "anywhere" }}>
                      {getFullName() || "Minha conta"}
                    </Typography>
                    {profile?.email && (
                      <Typography sx={{ fontFamily: "inherit", fontSize: 12.5, color: "#8C8478", overflowWrap: "anywhere" }}>
                        {profile.email}
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box sx={{ py: "6px" }}>
                  {[
                    { rotulo: "Meu painel", Icone: GridViewOutlinedIcon, rota: "/dashboard" },
                    ...(profile?.razao_social
                      ? []
                      : [{ rotulo: "Meu perfil", Icone: PersonOutlineOutlinedIcon, rota: "/dashboard/profilecurriculum" }]),
                    { rotulo: "Editar dados", Icone: EditOutlinedIcon, rota: profile?.razao_social ? "/empresa-account" : "/account" },
                    { rotulo: "Central de ajuda", Icone: HelpOutlineOutlinedIcon, rota: "/ajuda" },
                  ].map(({ rotulo, Icone, rota }) => (
                    <MenuItem
                      key={rotulo}
                      onClick={() => {
                        setAnchorElUser(null);
                        history.push(rota);
                      }}
                      sx={{ gap: "14px", px: "20px", py: "11px", fontFamily: "inherit", fontSize: 14.5, color: "#3B3833", "&:hover": { backgroundColor: "#FDFBF7" } }}
                    >
                      <Icone sx={{ fontSize: 20, color: "#6B655D" }} />
                      {rotulo}
                    </MenuItem>
                  ))}
                </Box>
                <Box sx={{ borderTop: "1px solid #F1EBE1", py: "6px" }}>
                  <MenuItem
                    onClick={() => {
                      setAnchorElUser(null);
                      handleSignOut();
                    }}
                    sx={{ gap: "14px", px: "20px", py: "11px", fontFamily: "inherit", fontSize: 14.5, fontWeight: 600, color: "#C63C33", "&:hover": { backgroundColor: "#FDF1EF" } }}
                  >
                    <LogoutOutlinedIcon sx={{ fontSize: 20 }} />
                    Sair da conta
                  </MenuItem>
                </Box>
              </Menu>

              {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.pg" /> */}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </ThemeProvider>
  );
};
export default withRouter(ResponsiveAppBar);
